import React, { useState, useContext, useMemo } from 'react';
import { Link } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import { usePermissions } from '../hooks/usePermissions';
import '../css/Sidebar.css';

import * as FiIcons from 'react-icons/fi';
import * as PiIcons from "react-icons/pi";
import * as MdIcons from "react-icons/md";

const FiMenu = FiIcons.FiMenu as unknown as React.FC;
const FiUsers = FiIcons.FiUsers as unknown as React.FC;
const FiClock = FiIcons.FiClock as unknown as React.FC;
const FiList = FiIcons.FiList as unknown as React.FC;
const FiLogOut = FiIcons.FiLogOut as unknown as React.FC;
const FiPackage = FiIcons.FiPackage as unknown as React.FC;
const FiMapPin = FiIcons.FiMapPin as unknown as React.FC;
const FiGrid = FiIcons.FiGrid as unknown as React.FC;
const FiPhoneCall = FiIcons.FiPhoneCall as unknown as React.FC;
const FiFileText = FiIcons.FiFileText as unknown as React.FC;
const PiMoney = PiIcons.PiMoneyWavyBold as unknown as React.FC;
const MdDashboard = MdIcons.MdDashboard as unknown as React.FC;
const FiCheckSquare = FiIcons.FiCheckSquare as unknown as React.FC;
const LOGO_URL = 'https://cdn.otaprime.com/logo-light-new.png';

const Sidebar: React.FC<{
  isMobile?: boolean;
  mobileOpen?: boolean;
  onRequestClose?: () => void;
}> = ({ isMobile = false, mobileOpen = false, onRequestClose }) => {
  const [collapsed, setCollapsed] = useState(false);
  const { logout } = useContext(AuthContext);
  const permissions = usePermissions();

  const menuItems = useMemo(() => {
    const items = [
      { label: 'Dashboard', icon: <MdDashboard />, path: '/dashboard', permission: 'canViewDashboard' as const },
      { label: 'Telecalling', icon: <FiPhoneCall />, path: '/telecalling', permission: 'canViewTelecalling' as const },
      { label: 'Customers', icon: <FiUsers />, path: '/customers', permission: 'canViewCustomers' as const },
      { label: 'Queries', icon: <FiList />, path: '/queries', permission: 'canViewQueries' as const },
      { label: 'Follow-ups', icon: <FiClock />, path: '/followups', permission: 'canViewFollowups' as const },
      { label: 'Bookings', icon: <PiMoney />, path: '/bookings', permission: 'canViewBookings' as const },
      { label: 'Destinations', icon: <FiMapPin />, path: '/destinations', permission: 'canViewDestinations' as const },
      { label: 'Hotels', icon: <FiGrid />, path: '/hotels', permission: 'canViewHotels' as const },
      { label: 'Packages', icon: <FiPackage />, path: '/packages', permission: 'canViewPackages' as const },
      { label: 'Quotations', icon: <FiFileText />, path: '/quotation/builder', permission: 'canViewQueries' as const },
      { label: 'Attendance', icon: <FiCheckSquare />, path: '/attendance', permission: 'canViewAttendance' as const },
    ];

    return items.filter(item => !item.permission || permissions[item.permission]);
  }, [permissions]);

  return (
    <div
      className={`sidebar ${collapsed ? 'collapsed' : ''} ${isMobile ? 'is-mobile' : ''} ${isMobile && mobileOpen ? 'mobile-open' : ''}`}
    >
      <div className="sidebar-header">
        {!collapsed && <div className="logo-crop"> <img src={LOGO_URL} alt="Logo" /> </div>}
        <button
          className="menu-btn"
          onClick={() => {
            if (isMobile) onRequestClose?.();
            else setCollapsed(!collapsed);
          }}
          aria-label={isMobile ? 'Close menu' : 'Toggle menu'}
        >
          <FiMenu />
        </button>
      </div>

      <nav className="sidebar-nav">
        <ul>
          {menuItems.map((item) => (
            <li key={item.label}>
              <Link
                to={item.path}
                className="sidebar-link"
                onClick={() => {
                  if (isMobile) onRequestClose?.();
                }}
              >
                {item.icon}
                {!collapsed && <span style={{ marginLeft: '12px' }}>{item.label}</span>}
              </Link>
            </li>
          ))}
        </ul>
      </nav>

      <div className="logout-section">
        <button className="logout-btn" onClick={logout}>
          <FiLogOut />
          {!collapsed && <span style={{ marginLeft: '12px' }}>Logout</span>}
        </button>
      </div>
    </div>
  );
};

export default Sidebar;
